import { render, staticRenderFns } from "./ComFooter.vue?vue&type=template&id=daa4811a&scoped=true"
import script from "./ComFooter.vue?vue&type=script&lang=js"
export * from "./ComFooter.vue?vue&type=script&lang=js"
import style0 from "./ComFooter.vue?vue&type=style&index=0&id=daa4811a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa4811a",
  null
  
)

export default component.exports